import Config from '@lib/Config'

export const getPhoneNumber = (mapping?: PhoneMapping, format = 'number'): string | null => {
    if (!mapping) {
        return null;
    }

    if (Config.utm_call) {
        if (format === 'number') {
            const parsed = Config.utm_call.replace(/\D/g,'');
            return parsed;
        } else {
            return Config.utm_call;
        }
    }

    if (Config.useStaticPhones) {
      return mapping['default'][format]
    }

    const isMedsupDirectMail = Config.utm_source === 'directmail' &&
                               Config.utm_term === 'medsup' &&
                               Config.utm_medium === 'mail';

    const source = Config.utm_source as string;
    const isUnderScope = source == 'radio' ||
                         source == 'facebook' ||
                         source == 'BingSearchNetwork' ||
                         source == 'GoogleSearchNetwork' ||
                         source == 'GoogleDisplayNetwork';

    if (Config.industryType === 'Life') {
      switch (Config.utm_term) {
        case '202002_high_net_worth_creative':
          return mapping.lifeNetCreative[format];
        case '202002_self_mailer_creative':
          return mapping.lifeMailerCreative[format];
        case '202002_10_stealth_creative':
          return mapping.lifeStealthCreative[format];
      }

      if (Config.productType === 'Guaranteed Issue') {
        return mapping.lifeGuaranteedIssue[format];
      }
    }

    if (Config.utm_source === 'GoogleSearchNetwork' ||
        Config.utm_source === 'GoogleDisplayNetwork') {

        if (Config.utm_campaign === '10360114754' ||
            Config.utm_campaign === '10367303677' ||
            Config.utm_campaign === '10371384669' ||
            Config.utm_campaign === '10367304913' ||
            Config.utm_campaign === '10648965838' ||
            Config.utm_campaign === '10649874890' ||
            Config.utm_campaign === '10650439848' ||
            Config.utm_campaign === '10657078938') {

            if (format === 'number') {
                return '8559444603';
            } else {
                return '(855) 944-4603';
            }
        }
    }

    if (isMedsupDirectMail) {
        return mapping[source][format];
    }

    if (isUnderScope) {
        return mapping[source][format];
    }

    if (Config.industryType === 'PNC') {
      return mapping.autoInsurance[format]
    }

    return mapping['default'][format]
};
